<template>
  <v-card class="card-container">
    <div class="main-toolbar">
      <div class="icon-back">
        <v-img
          src="../../../assets/figmaIcons/white/stock.svg"
          max-width="55%"
        ></v-img>
      </div>

      <span class="main-toolbar-title">{{ $t('Estoque') }}</span>

      <v-spacer></v-spacer>
    </div>

    <div class="mt-4">
      <v-tabs
        color="secondary"
        v-model="tab"
        :height="40"
        :mobile-break-point="300"
        class="ma-auto"
        icons-and-text
      >
        <v-tabs-slider color="#BBCF20"></v-tabs-slider>
        <v-tab
          v-if="institution.userType != 4"
          active-class="activated-tab"
          class="rounded-lg rounded-b-0"
        >
          Itens
        </v-tab>
        <v-tab active-class="activated-tab" class="rounded-lg rounded-b-0">
          {{ $t('Relatório') }}
        </v-tab>
      </v-tabs>
    </div>

    <v-tabs-items v-model="tab">
      <v-tab-item v-if="institution.userType != 4">
        <div class="d-flex justify-end">
          <v-btn
            dark
            class="terciary-button mr-4"
            depressed
            @click="exportToExcel"
          >
            {{ $t('Exportar para excel') }}
          </v-btn>
          <v-btn dark class="secondary-button mr-4" depressed to="stock/manage">
            {{ $t('Novo item') }}
          </v-btn>
          <v-btn
            dark
            class="primary-button mr-0"
            depressed
            @click="show = !show"
          >
            {{ show ? $t('Fechar') : $t('Filtros') }}
          </v-btn>
        </div>

        <v-expand-transition>
          <div v-show="show">
            <v-form ref="form">
              <v-row class="ma-0" align="center" justify="end" dense>
                <v-col cols="auto">
                  <span class="text ml-1">{{ $t('Nome') }}</span>
                  <v-text-field
                    class="primary-input"
                    hide-details="auto"
                    placeholder="Pesquisar"
                    v-model="filter.name"
                    outlined
                    @keyup.enter="applyFilter"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="auto">
                  <span class="text ml-1">{{ $t('Código') }}</span>
                  <v-text-field
                    class="primary-input"
                    hide-details="auto"
                    placeholder="Pesquisar"
                    v-model="filter.code"
                    outlined
                    @keyup.enter="applyFilter"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="auto">
                  <span class="text ml-1">{{ $t('Unidade') }}</span>
                  <v-autocomplete
                    :loading="unidLoading"
                    :items="unidades"
                    hide-details="auto"
                    item-text="name"
                    item-value="id"
                    v-model="filter.unidadeId"
                    append-icon="mdi-chevron-down"
                    class="primary-input"
                    :placeholder="$t('Pesquisar por nome')"
                    outlined
                    @keyup.enter="applyFilter"
                  >
                  </v-autocomplete>
                </v-col>

                <v-col cols="auto">
                  <span class="text ml-1">{{ $t('Data inicial') }}</span>
                  <v-menu
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        placeholder="00/00/0000"
                        :value="formatDate(filter.start)"
                        hide-details="auto"
                        clearable
                        outlined
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        @keyup.enter="applyFilter"
                        autocomplete="off"
                        class="primary-input mr-2"
                      ></v-text-field>
                    </template>
                    <v-date-picker locale="pt" v-model="filter.start" no-title>
                    </v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="auto">
                  <span class="text ml-1">{{ $t('Data final') }}</span>
                  <v-menu
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        class="primary-input"
                        placeholder="00/00/0000"
                        :value="formatDate(filter.final)"
                        :rules="
                          filter.start
                            ? [
                                () =>
                                  filter.final >= filter.start ||
                                  'Data inválida',
                              ]
                            : []
                        "
                        :disabled="!filter.start"
                        prepend-inner-icon="mdi-calendar"
                        outlined
                        readonly
                        hide-details="auto"
                        v-bind="attrs"
                        v-on="on"
                        @keyup.enter="applyFilter"
                      ></v-text-field>
                    </template>
                    <v-date-picker locale="pt" v-model="filter.final" no-title>
                    </v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="auto">
                  <span class="text ml-1">{{ $t('Estoque') }}</span>
                  <v-autocomplete
                    :items="[
                      { text: 'Todos', value: null },
                      { text: 'Possui estoque', value: true },
                      { text: 'Não possui estoque', value: false },
                    ]"
                    hide-details="auto"
                    item-text="text"
                    item-value="value"
                    v-model="filter.haveStock"
                    append-icon="mdi-chevron-down"
                    class="primary-input"
                    :placeholder="$t('Pesquisar por nome')"
                    outlined
                    @keyup.enter="applyFilter"
                  >
                    <template v-slot:selection="{ item }">
                      <span class="text-caption">
                        {{ $t(item.text) }}
                      </span>
                    </template>

                    <template v-slot:item="{ item }">
                      <span class="text-caption">
                        {{ $t(item.text) }}
                      </span>
                    </template>
                  </v-autocomplete>
                </v-col>

                <v-col cols="auto">
                  <span class="text ml-1">{{
                    $t('Quantidade mínima atingida')
                  }}</span>
                  <v-autocomplete
                    :items="[
                      { text: 'Sim', value: true },
                      { text: 'Não', value: false },
                    ]"
                    clearable
                    hide-details="auto"
                    item-text="text"
                    item-value="value"
                    v-model="filter.minimumQuantity"
                    append-icon="mdi-chevron-down"
                    class="primary-input"
                    :placeholder="$t('Quantidade')"
                    outlined
                    @keyup.enter="applyFilter"
                  >
                    <template v-slot:selection="{ item }">
                      <span class="text-caption">
                        {{ $t(item.text) }}
                      </span>
                    </template>

                    <template v-slot:item="{ item }">
                      <span class="text-caption">
                        {{ $t(item.text) }}
                      </span>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
              <div class="d-flex justify-end">
                <v-btn class="clear-button mr-2" depressed @click="reset">
                  {{ $t('Limpar') }}
                </v-btn>
                <v-btn @click="applyFilter" class="secondary-button" depressed>
                  {{ $t('Aplicar filtros') }}
                </v-btn>
              </div>
            </v-form>
          </div>
        </v-expand-transition>

        <v-data-table
          :headers="headers"
          :items="items"
          :items-per-page="filter.pageSize"
          class="main-table"
          hide-default-footer
          hide-default-header
          mobile-breakpoint="0"
          :loading="loading"
        >
          <template #header="{ props, on }">
            <thead>
              <tr>
                <th
                  class="text-center"
                  v-for="header in props.headers"
                  :key="header.value"
                >
                  <v-simple-checkbox
                    v-if="header.value === 'data-table-select'"
                    v-model="props.everyItem"
                    :indeterminate="props.someItems && !props.everyItem"
                    color="purple"
                    @input="on['toggle-select-all']"
                  ></v-simple-checkbox>

                  <div>
                    <v-hover v-slot="{ hover }">
                      <div>
                        <span>{{ $t(header.text) }}</span>
                        <v-icon
                          v-if="
                            hover &&
                            header.value != 'data-table-select' &&
                            header.value != 'actions'
                          "
                          color="white"
                          class="mx-2"
                          @click="on.sort(header.value)"
                        >
                          {{
                            props.options.sortBy.includes(header.value)
                              ? `mdi-chevron-down`
                              : `mdi-chevron-up`
                          }}
                        </v-icon>
                      </div>
                    </v-hover>
                  </div>
                </th>
              </tr>
            </thead>
          </template>

          <template #[`item.name`]="{ item }">
            <span
              :class="
                item.totalQuantity < item.minimumQuantity ? 'red--text' : ''
              "
            >
              {{ item.name }}
            </span>
          </template>

          <template #[`item.unit`]="{ item }">
            <span> {{ item.unit ? item.unit : 'Unidade' }} </span>
          </template>

          <template #[`item.code`]="{ item }">
            <span> {{ item.code ? item.code : '-' }} </span>
          </template>

          <template #[`item.createdAt`]="{ item }">
            <span> {{ formatDate(item.createdAt) }} </span>
          </template>

          <template #[`item.totalValue`]="{ item }">
            <span> {{ formatCurrency(item.totalValue) }} </span>
          </template>

          <template #[`item.actions`]="{ item }">
            <v-tooltip bottom>
              <template #activator="{ on }">
                <v-btn
                  class="ma-1"
                  color="#0F3565"
                  dark
                  small
                  depressed
                  :to="`/stock/manage?id=${item.id}`"
                  v-on="on"
                >
                  <v-icon size="22">mdi-pencil-outline</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('Editar') }}</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template #activator="{ on }">
                <v-btn
                  class="ma-1"
                  color="#921616"
                  dark
                  depressed
                  small
                  @click="openDelete(item)"
                  v-on="on"
                >
                  <v-icon size="22">mdi-trash-can-outline</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('Excluir') }}</span>
            </v-tooltip>
          </template>
        </v-data-table>

        <div class="pagination mx-2">
          <div class="item-pagination block-one">
            <v-menu bottom offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  class="btn"
                  depressed
                  color="#C0C0C0"
                  small
                >
                  qtd: {{ filter.pageSize }}
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(size, i) in sizes"
                  :key="i"
                  @click="filter.pageSize = size"
                >
                  <v-list-item-title>{{ size }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <div class="registros" v-if="items.length">
              <span> 1 - {{ items.length }} de {{ filter.totalItems }} </span>
              <br />
            </div>
          </div>

          <div class="item-pagination block-two">
            <v-pagination
              class="pagination-item"
              v-model="filter.page"
              :length="filter.totalPages"
              :total-visible="5"
            ></v-pagination>
          </div>
        </div>
      </v-tab-item>

      <v-tab-item>
        <div class="d-flex justify-end">
          <v-btn
            class="primary-button mr-0 ma-1"
            depressed
            @click="show = !show"
          >
            {{ show ? $t('Fechar') : $t('Filtros') }}
          </v-btn>
          <v-btn class="primary-button mr-0 ma-1" depressed @click="excel">
            Exportar para Excel
          </v-btn>
        </div>

        <v-expand-transition>
          <div v-show="show">
            <v-form ref="repForm">
              <v-row class="ma-0" align="center" dense>
                <v-col cols="auto">
                  <span class="text ml-1">{{ $t('Nome do item') }}</span>
                  <v-text-field
                    v-model="reportFilter.name"
                    class="primary-input"
                    :placeholder="$t('Digite o nome do item')"
                    hide-details="auto"
                    outlined
                    @keyup.enter="applyReportFilter"
                  ></v-text-field>
                </v-col>
                <v-col cols="auto">
                  <span class="text ml-1">{{ $t('Data inicial') }}</span>
                  <v-menu
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        class="primary-input"
                        placeholder="00/00/0000"
                        :value="formatDate(reportFilter.start)"
                        prepend-inner-icon="mdi-calendar"
                        hide-details="auto"
                        outlined
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        @keyup.enter="applyReportFilter"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      locale="pt"
                      v-model="reportFilter.start"
                      no-title
                    >
                    </v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="auto">
                  <span class="text ml-1">{{ $t('Data final') }}</span>
                  <v-menu
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        class="primary-input"
                        placeholder="00/00/0000"
                        :value="formatDate(reportFilter.final)"
                        :rules="
                          reportFilter.start
                            ? [
                                () =>
                                  reportFilter.final >= reportFilter.start ||
                                  'Data inválida',
                              ]
                            : []
                        "
                        :disabled="!reportFilter.start"
                        prepend-inner-icon="mdi-calendar"
                        outlined
                        readonly
                        hide-details="auto"
                        v-bind="attrs"
                        v-on="on"
                        @keyup.enter="applyReportFilter"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      locale="pt"
                      v-model="reportFilter.final"
                      no-title
                    >
                    </v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="auto">
                  <label class="label">{{ $t('Unidade') }}</label>
                  <v-autocomplete
                    hide-details="auto"
                    chips
                    clearable
                    item-text="name"
                    item-value="id"
                    v-model="filter.unidadeIds"
                    :items="unidades"
                    multiple
                    deletable-chips
                    small-chips
                    outlined
                    class="primary-input"
                    placeholder="Todas"
                    :search-input.sync="unitSearch"
                    @blur="unitSearch = ''"
                    @keyup.enter="applyReportFilter"
                  >
                    <template v-slot:selection="{ attrs, item, select, selected }">
                      <v-chip
                        v-bind="attrs"
                        :input-value="selected"
                        close
                        color="#BBCF20"
                        text-color="#fff"
                        small
                        @click="select"
                        @click:close="removeUnit(item)"
                      >
                        <span class="text-caption" style="text-transform: none">
                          {{ $t(item.name) }}
                        </span>
                      </v-chip>
                    </template>

                    <template v-slot:item="{ item }">
                      <span class="text-caption">
                        {{ $t(item.name) }}
                      </span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="auto">
                  <label class="label">{{ $t('Setor') }}</label>

                  <v-autocomplete
                    hide-details="auto"
                    v-model="filter.departmentIds"
                    :items="filteredDepartments"
                    item-text="name"
                    item-value="id"
                    multiple
                    :loading="departmentLoading"
                    outlined
                    class="primary-input"
                    @keyup.enter="applyReportFilter"
                    :search-input.sync="search"
                    @blur="search = ''"
                    clearable
                    chips
                    deletable-chips
                    small-chips
                  >
                    <template
                      v-slot:selection="{ attrs, index, item, select, selected }"
                    >
                      <v-chip
                        v-bind="attrs"
                        :input-value="selected"
                        close
                        color="#BBCF20"
                        text-color="#fff"
                        small
                        @click="select"
                        @click:close="removeDepartment(index)"
                      >
                        {{ item.name }}
                      </v-chip>
                    </template>
                    <template v-slot:item="{ item }">
                      <span class="text-caption" v-if="item.unidade">
                        {{ item.name }} / {{ item.unidade.name }}
                      </span>
                      <span class="text-caption" v-else>
                        {{ item.name }}
                      </span>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
              <div class="d-flex justify-end">
                <v-btn class="clear-button mr-2" depressed @click="reportReset">
                  {{ $t('Limpar') }}
                </v-btn>
                <v-btn
                  @click="applyReportFilter"
                  class="secondary-button"
                  depressed
                >
                  {{ $t('Aplicar filtros') }}
                </v-btn>
              </div>
            </v-form>
          </div>
        </v-expand-transition>

        <v-data-table
          :headers="reportHeaders"
          :items="reportData"
          :items-per-page="reportFilter.pageSize"
          class="main-table"
          hide-default-footer
          hide-default-header
          mobile-breakpoint="0"
        >
          <template #header="{ props, on }">
            <thead>
              <tr>
                <th
                  class="text-center"
                  v-for="header in props.headers"
                  :key="header.value"
                >
                  <v-simple-checkbox
                    v-if="header.value === 'data-table-select'"
                    v-model="props.everyItem"
                    :indeterminate="props.someItems && !props.everyItem"
                    color="purple"
                    @input="on['toggle-select-all']"
                  ></v-simple-checkbox>

                  <div>
                    <v-hover v-slot="{ hover }">
                      <div>
                        <span>{{ $t(header.text) }}</span>
                        <v-icon
                          v-if="
                            hover &&
                            header.value != 'data-table-select' &&
                            header.value != 'actions'
                          "
                          color="white"
                          class="mx-2"
                          @click="on.sort(header.value)"
                        >
                          {{
                            props.options.sortBy.includes(header.value)
                              ? `mdi-chevron-down`
                              : `mdi-chevron-up`
                          }}
                        </v-icon>
                      </div>
                    </v-hover>
                  </div>
                </th>
              </tr>
            </thead>
          </template>

          <template #[`item.osNumber`]="{ item }">
            <span> {{ item.osNumber ? item.osNumber : '-' }} </span>

            <v-tooltip bottom v-if="item.hasOs">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="ma-1"
                  depressed
                  small
                  color="#BBCF20"
                  v-bind="attrs"
                  v-on="on"
                  @click="getServiceOrderbyNum(item.osNumber)"
                >
                  <v-icon small class="ma-1" color="#F5F5F5">
                    mdi-file-document-multiple-outline
                  </v-icon>
                </v-btn>
              </template>
              <span>{{ $t('Visualizar O.S') }}</span>
            </v-tooltip>
          </template>

          <template #[`item.move`]="{ item }">
            <span> {{ item.move ? $t(item.move) : '-' }} </span>
          </template>

          <template #[`item.date`]="{ item }">
            <span> {{ item.date ? formatDate(item.date) : '-' }} </span>
          </template>

          <template #[`item.moveValue`]="{ item }">
            <span>
              {{ formatCurrency(item.moveValue) }}
            </span>
          </template>
        </v-data-table>

        <div class="pagination mx-2">
          <div class="item-pagination block-one">
            <div class="registros" v-if="reportData.length">
              <span>
                1 - {{ reportData.length }} de {{ reportFilter.totalItems }}
              </span>
              <br />
              <!-- <span>
            Selecionados:
            {{ items.length }}
          </span> -->
            </div>
          </div>

          <div class="item-pagination block-two">
            <v-pagination
              class="pagination-item"
              v-model="reportFilter.page"
              :length="reportFilter.totalPages"
              :total-visible="5"
            ></v-pagination>
          </div>
        </div>
      </v-tab-item>
    </v-tabs-items>

    <v-dialog v-model="deleteDialog" :key="deleteKey" max-width="300">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="blue-grey darken-3"
          dark
        >
          <div class="grey--text text--lighten-1 text-body-2 mb-4">
            {{ $t('Tem certeza de que deseja excluir o item') }}
            {{ currentItem.name }}?
          </div>

          <v-btn
            :disabled="loading"
            class="ma-1"
            color="grey"
            text
            @click="deleteDialog = false"
          >
            {{ $t('Cancelar') }}
          </v-btn>

          <v-btn
            :loading="loading"
            class="ma-1"
            color="error"
            text
            @click="remove"
          >
            {{ $t('Excluir') }}
          </v-btn>
        </v-sheet>
      </div>
    </v-dialog>
  </v-card>
</template>

<script>
import ApiService from '../../../services/ApiService'
import FormatDate from '../../../Utils/FormatDate'

export default {
  name: 'StockPage',

  data() {
    return {
      localDepartments: [],
      tab: 0,
      apiService: new ApiService(),
      show: false,
      loading: false,
      items: [],
      currentItem: [],
      unidades: [],
      unidLoading: false,
      sizes: [10, 30, 90, 180],
      filter: {
        haveStock: null,
        name: '',
        start: '',
        final: '',
        code: '',
        institutionId: null,
        unidadeId: null,
        id: null,
        page: 1,
        pageSize: 10,
        totalItems: 0,
        totalPages: 0,
        unidadeIds: [],
        departmentIds: [],
      },
      reportFilter: {
        institutionId: null,
        start: '',
        final: '',
        page: 1,
        pageSize: 10,
        totalItems: 0,
        totalPages: 0,
        unidadeIds: [],
        departmentIds: [],
      },
      headers: [
        {
          text: '',
          align: 'center',
          value: '',
          sortable: false,
        },
        {
          text: 'Item',
          align: 'center',
          value: 'name',
        },
        {
          text: 'Código',
          align: 'center',
          value: 'code',
        },
        {
          text: 'Quantidade em estoque',
          align: 'center',
          value: 'totalQuantity',
        },
        {
          text: 'Unidade de medida',
          align: 'center',
          value: 'unit',
        },
        {
          text: 'Valor total',
          align: 'center',
          value: 'totalValue',
        },
        {
          text: 'Data de criação',
          align: 'center',
          value: 'createdAt',
        },
        {
          text: '',
          align: 'center',
          value: 'actions',
          sortable: false,
        },
      ],
      reportHeaders: [
        {
          text: '',
          align: 'center',
          value: '',
          sortable: false,
        },
        {
          text: 'Item',
          align: 'center',
          value: 'itemName',
        },
        {
          text: 'Movimentação',
          align: 'center',
          value: 'move',
        },
        {
          text: 'Data',
          align: 'center',
          value: 'date',
        },
        {
          text: 'QTD inicial',
          align: 'center',
          value: 'initialQtd',
        },
        {
          text: 'QTD final',
          align: 'center',
          value: 'finalQtd',
        },
        {
          text: 'Usuário',
          align: 'center',
          value: 'username',
        },
        {
          text: 'Custo da movimentação',
          align: 'center',
          value: 'moveValue',
        },
        {
          text: 'N. OS / Motivo',
          align: 'center',
          value: 'osNumber',
        },
      ],
      institution: {},
      deleteDialog: false,
      deleteKey: false,
      reportData: [],
      user: {},
      serviceOrders: null,
      serviceOrderfilter: {
        serviceOrderType: [5],
        institutionId: null,
      },
    }
  },

  created() {
    this.user = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.filter.institutionId = this.institution.id
    this.reportFilter.institutionId = this.institution.id
    this.serviceOrderfilter.institutionId = this.institution.id

    this.list()
    this.getReport()
    this.getUnidades()
    this.getDepartments()
  },

  computed: {
    filteredDepartments() {
      // Se não houver unidades selecionadas, retorna todos os departamentos locais
      if (!this.filter.unidadeIds || this.filter.unidadeIds.length === 0) {
        return this.localDepartments || [];
      }
      // Filtra departamentos conforme unidades selecionadas
      return (this.localDepartments || []).filter((department) =>
        this.filter.unidadeIds.includes(department.unidadeId)
      );
    },
  },

  methods: {
    async getServiceOrderbyNum(num) {
      await this.apiService
        .get(
          `serviceOrder/get-by-num?num=${num}&institutionId=${this.institution.id}`
        )
        .then((response) => {
          const route = this.$router.resolve({
            path: `/editServiceOrder/${response.content.id}`,
          })
          window.open(route.href, '_blank')
        })
        .catch(() => {
          this.loading = false
        })
    },

    removeUnit(item) {
      if (!this.filter.unidadeIds) return;
      const idx = this.filter.unidadeIds.indexOf(item.id);
      if (idx !== -1) {
        this.filter.unidadeIds.splice(idx, 1);
        this.filter.unidadeIds = [...this.filter.unidadeIds];
      }
    },

    removeDepartment(index) {
      if (!this.filter.departmentIds) return;
      this.filter.departmentIds.splice(index, 1);
      this.filter.departmentIds = [...this.filter.departmentIds];
    },

    async getUserUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .get(`unidade/listByUserAndInstitution/${this.institutionId}`)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
    },

    async getDepartments() {
      this.departmentLoading

      await this.apiService
        .get(`department/listActive/${this.institution.id}`)
        .then((response) => {
          this.departments = response.content
          this.localDepartments = this.departments.filter((x) =>
            this.unidades.map((x) => x.id).includes(x.unidadeId)
          )
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.departmentLoading = false
    },

    excel() {
      this.apiService
        .post('stockitem/report/excel', this.reportFilter)
        .then((response) => {
          var excelResult = `data:application/octet-stream;base64,${response.content}`
          const link = document.createElement('a')
          link.href = excelResult
          link.setAttribute('download', 'estoque-relatorio.xlsx')
          document.body.appendChild(link)
          link.click()
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    formatCurrency(value) {
      return value != null ? value.toInstLocale() : 0
    },

    openDelete(item) {
      this.currentItem = item
      this.deleteKey = !this.deleteKey
      this.deleteDialog = true
    },

    remove() {
      this.loading = true
      this.apiService
        .delete(`stockItem/${this.currentItem.id}`)
        .then(() => {
          this.list()
          this.$toast.success(this.$t('Item excluído com sucesso!'))
          this.loading = false
          this.deleteDialog = false
        })
        .catch(() => {
          this.loading = false
          this.deleteDialog = false
        })
    },

    async getUnidades() {
      this.unidLoading = true

      await this.apiService
        .get(`unidade/listByUserAndInstitution/${this.institution.id}`)
        .then((response) => {
          this.unidades = response.content
          this.unidLoading = false
        })
        .catch(() => {
          this.unidLoading = false
        })
    },

    formatDate(date) {
      return FormatDate.dateTime(date)
    },

    applyReportFilter() {
      // Sincroniza os campos de unidade/setor do filtro visual para o reportFilter
      this.reportFilter.unidadeIds = Array.isArray(this.filter.unidadeIds) ? [...this.filter.unidadeIds] : [];
      this.reportFilter.departmentIds = Array.isArray(this.filter.departmentIds) ? [...this.filter.departmentIds] : [];
      if (this.$refs.repForm.validate()) {
        this.getReport();
      }
    },

    applyFilter() {
      if (this.$refs.form.validate()) {
        this.list()
      }
    },

    reset() {
      this.filter.haveStock = null
      this.filter.page = 1
      this.filter.id = null
      this.filter.unidadeId = null
      this.filter.name = ''
      this.filter.start = ''
      this.filter.final = ''
      this.list()
    },

    reportReset() {
      this.reportFilter.name = '';
      this.filter.page = 1;
      this.filter.start = '';
      this.filter.final = '';
      this.filter.unidadeIds = [];
      this.filter.departmentIds = [];
      this.reportFilter.unidadeIds = [];
      this.reportFilter.departmentIds = [];
      this.getReport();
    },

    getReport() {
      this.apiService
        .post('stockitem/report', this.reportFilter)
        .then((response) => {
          this.reportData = response.content.entities

          const pager = response.content.pager
          this.reportFilter.page = pager.currentPage
          this.reportFilter.pageSize = pager.pageSize
          this.reportFilter.totalItems = pager.totalItems
          this.reportFilter.totalPages = pager.totalPages
        })
    },

    list() {
      this.loading = true
      this.apiService
        .post('stockitem/list/paginate', this.filter)
        .then((response) => {
          this.loading = false
          this.items = response.content.entities

          const pager = response.content.pager
          this.filter.page = pager.currentPage
          this.filter.pageSize = pager.pageSize
          this.filter.totalItems = pager.totalItems
          this.filter.totalPages = pager.totalPages
        })
        .catch(() => {
          this.loading = false
        })
    },
    async exportToExcel() {
      const response = await this.apiService.post(
        `stockitem/export-to-excel`,
        this.filter
      )
      try {
        if (response.statusCode === 200) {
          const fileBase64 = response.content
          const fileBytes = atob(fileBase64)
          const byteArray = new Uint8Array(fileBytes.length)
          for (let i = 0; i < fileBytes.length; i++) {
            byteArray[i] = fileBytes.charCodeAt(i)
          }
          const blob = new Blob([byteArray], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          })
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'itensEmEstoque.xlsx')
          document.body.appendChild(link)
          link.click()
        } else {
          this.$toast.error('Nenhum item encontrado para exportação.')
        }
      } catch (error) {
        this.$toast.error('Erro ao exportar usuários:', error)
      }
    },
  },

  watch: {
    'filter.unidadeIds': {
      deep: true,
      handler() {
        this.getDepartments();
      },
    },
    'filter.pageSize': {
      deep: true,
      handler() {
        this.list()
      },
    },
    'filter.page': {
      deep: true,
      handler() {
        this.list()
      },
    },
    'reportFilter.page': {
      deep: true,
      handler() {
        this.getReport()
      },
    },
  }
}
</script>

<style scoped lang="scss">
.v-tabs--icons-and-text > .v-tabs-bar .v-tab {
  flex-direction: row-reverse;
}

.v-tab.v-tab {
  color: #bbcf20;
}

.v-tab {
  text-transform: none;
}

.v-tab--active {
  background-color: #e7eaeb;
}
</style>
